import { render, staticRenderFns } from "./calc-ix.vue?vue&type=template&id=14674b38"
import script from "./calc-ix.vue?vue&type=script&lang=js"
export * from "./calc-ix.vue?vue&type=script&lang=js"
import style0 from "./calc-ix.vue?vue&type=style&index=0&id=14674b38&prod&lang=scss"
import style1 from "../../assets/site.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports